"use strict";
exports.isThisWeek = isThisWeek;
var _index = require("./constructNow.js");
var _index2 = require("./isSameWeek.js");
function isThisWeek(date, options) {
  return (0, _index2.isSameWeek)(date, (0, _index.constructNow)(date), options);
}
